import { useEffect } from "react";

import { useDispatch } from "react-redux";

import {
    resetSignalsSourceAction,
    setSignalsSourceAction,
} from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

import { getPlaybookSignalSource } from "../utils/getPlaybookSignalSource";

/**
 * Playbook scoring uses platform vs account signals depending on the "shared with
 * account" toggle. Fetching happens at the page container; this hook only switches
 * the active source when that toggle changes.
 */
export const usePlaybookSignalSource = (isSharedWithAccount: boolean): void => {
    const dispatch = useDispatch();
    const signalSource = getPlaybookSignalSource(isSharedWithAccount);

    useEffect(() => {
        dispatch(setSignalsSourceAction(signalSource));

        return () => {
            dispatch(resetSignalsSourceAction());
        };
    }, [dispatch, signalSource]);
};
